module.exports = __webpack_public_path__ + "static/media/success1.79f370b7.gif";